import { useEffect } from 'react';
import { endKioskSession } from './kioskSession';
import { KIOSK_SIGNED_OUT_NOTICE } from './kioskFlag';

export const KIOSK_IDLE_MS = 20 * 60 * 1000;
/** How often the idle clock is read; the minute of slack is the cost of not re-arming a timer on every touch. */
const CHECK_MS = 15 * 1000;
const ACTIVITY_EVENTS = ['pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel'];

/**
 * Signs a PIN session out after twenty minutes without a pointer or key event. A shared iPad
 * left on one trainer's page is the trainer's name on the next person's work.
 *
 * Activity only writes a timestamp, and one interval reads it, so a stream of pointermove
 * events costs nothing. The clock is also read when the tab comes back to the front: timers
 * freeze while the iPad sleeps, so a trainer who walked off must not find the page still open.
 */
export function useKioskIdle(enabled) {
    useEffect(() => {
        if (!enabled) return undefined;
        let lastActivity = Date.now();
        let interval = null;
        const touch = () => {
            lastActivity = Date.now();
        };
        const check = () => {
            if (Date.now() - lastActivity >= KIOSK_IDLE_MS) {
                // Once is enough: the sign-out tears this hook down, but not before the next tick
                // could have announced it a second time.
                clearInterval(interval);
                endKioskSession(KIOSK_SIGNED_OUT_NOTICE);
            }
        };
        const onVisible = () => {
            if (document.visibilityState === 'visible') check();
        };
        ACTIVITY_EVENTS.forEach((name) => window.addEventListener(name, touch, { passive: true }));
        document.addEventListener('visibilitychange', onVisible);
        interval = setInterval(check, CHECK_MS);
        return () => {
            ACTIVITY_EVENTS.forEach((name) => window.removeEventListener(name, touch));
            document.removeEventListener('visibilitychange', onVisible);
            clearInterval(interval);
        };
    }, [enabled]);
}
